import React, {useContext, useEffect, useState} from 'react'
import {Link} from "react-router-dom";
import authContext from "../../context/auth/authContext";
import {useAlert} from 'react-alert'
import Swal from 'sweetalert2'
import axios from "axios";


const Login = () => {
    const AuthContext = useContext(authContext);
    const alert = useAlert()
    const {auth, login, clearAlert} = AuthContext;
    let [disable_button, setDisable_button] = useState(false);
    let [hide_spinner, setHide_spinner] = useState("d-none");

    useEffect(() => {
        if (auth.message.msg !== "") {
            alert.show(
                auth.message.msg, auth.message.msg_options
            )
            clearAlert()
            setDisable_button(false)
            setHide_spinner("d-none")
        }
    }, [auth.message.msg])

    const submitHandler = async (e) => {
        e.preventDefault();
        setDisable_button(true);
        setHide_spinner("d-inline-block");
        let login_form = document.getElementById("login_form");

        let user_data = new FormData(login_form);
        let res = await login(user_data);
        if (res.request.status === 403) {
            Swal.fire({
                title: "Account not activated",
                text:"please enter your email address to receive an activation link",
                input: 'email',
                inputAttributes: {
                    autocapitalize: 'off',
                    placeholder: "email address",
                    name: "email",
                    id: "resend_activation",
                    required: true
                },
                showCancelButton: true,
                confirmButtonText: 'Send activation link',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    let email = document.getElementById("resend_activation").value;
                    let data = new FormData();
                    data.append("email", email)
                    return axios.post(
                        `https://hailing-backend.herokuapp.com/auth/user/resend_activation`,
                        data
                    )
                        .then(res => {
                            if (res.request.status === 200) {

                                Swal.fire({
                                    icon: 'success',
                                    title: "Activation link sent successfully",
                                    text: "Check your email inbox",
                                })
                                // return res.request.statusText;
                            } else if (parseInt(res.status) === 204) {
                                Swal.fire({
                                    icon: 'error',
                                    title: "Email not found",
                                    text: "Email address does not exist on our records",
                                })
                            } else {
                                Swal.showValidationMessage(
                                    `Request failed: ${res.request.statusText}`
                                )
                            }
                        })
                        .catch(res => {
                            console.log(res.status);
                            if (res.request.status === 0) {
                                Swal.fire({
                                    icon: 'error',
                                    title: "Network error",
                                    text: "please check your internet connection",
                                })
                            } else {
                                Swal.showValidationMessage(
                                    `Request failed: ${res.request.statusText}`
                                )
                            }
                        })
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: `${result.value.login}'s avatar`,
                        imageUrl: result.value.avatar_url
                    })
                }
            })

        }
    }

    return (
        <div className="login-sect">
            <div className="split-grid-sect">
                <div className="split-grid-2 h-100 bg-white">
                    <div className="login-details-show d-flex justify-content-center align-items-center h-100">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8 mx-auto">
                                    <h2 className="make-bold">Log in</h2>
                                    <p>An account, with powerful, personalised tools all in one place</p>
                                    <form onSubmit={submitHandler}
                                          id="login_form">
                                        <div className="form-group">
                                            <label>Email Address</label>
                                            <input type="text" className="form-control" name="email"
                                                   placeholder="Email Address" required/>
                                        </div>
                                        <div className="form-group">
                                            <label>Password</label>
                                            <input type="password" className="form-control" name="password"
                                                   placeholder="Password" required/>
                                        </div>
                                        <div className="form-group form-check">
                                            <input type="checkbox" className="form-check-input" id="loginCheck1"/>
                                            <label className="form-check-label" htmlFor="loginCheck1">Remember
                                                Me</label>
                                        </div>
                                        <div className="form-group">
                                            <button type="submit"
                                                    className="btn btn-gravity-secondary text-white make-medium btn-block "
                                                    disabled={disable_button}>
                                                Log in
                                                <span
                                                    className={"spinner-border spinner-border-sm ml-2 " + hide_spinner}
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </button>
                                        </div>
                                    </form>
                                    <div className="text-center mb-3">
                                        <small className="text-uppercase">
                                            <Link to="#" className="text-dark make-medium">Forgot
                                                Password?
                                            </Link>
                                        </small>
                                    </div>
                                    <div className="text-center">
                                        <Link to="/register" className="text-gravity-secondary">
                                            <span className="make-medium">Don't have an account? Sign Up </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="split-grid-1 bg-primary add-bg-image position-relative d-none d-xl-block d-lg-block">

                    <div id="carouselAdminIndicators" className="carousel slide" data-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <div className="add-overlay"></div>
                                <div className="img-holder-10">
                                    <img src="images/banner-3.jpg" className="d-block w-100 ob-fit vh-100-2"
                                         alt="..."/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Login